import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { enableProdMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DirectivesModule } from '@directives/directives.module';
import { FoundationModule } from '@foundation/foundation.module';
import { ReportsModule } from "@reports/reports.module";
import { ServicesModule } from '@services/_services.module';
import { TemperatureModule } from "@temperature/temperature.module";
//import { RaygunErrorHandler } from 'src/app/app.raygun.setup';
import { AlertsModule } from "src/app/main/modules/alerts/alerts.module";
import { AuthInterceptor } from "./authInterceptor";
import { VisualisationsModule } from "./directives/_visualisations/visualisations.module";
import { ComponentsModule } from './main/components/components.modules';
import { TachoModule } from './main/components/tacho/_tacho.module';
import { CameraModule } from "./main/modules/cameras/camera.module";
import { DashboardModule } from "./main/modules/dashboard/dashboard.module";
import { FleetModule } from './main/modules/fleet/fleet.module';
import { FoundationJobsModule } from "./main/modules/foundation/_routes/jobs/jobs.module";
import { HelpModule } from "./main/modules/help/help.module";
import { MaintenanceModule } from "./main/modules/maintenance/maintenance.module";
import { TmsModule } from './main/modules/tms/tms.module';
import { RequestInterceptor } from "./request.interceptor";
import { PipesModule } from "./_pipes/_pipes.module";

// Prevents veriTable from going very slowly... May result in poor error messages?
enableProdMode();

@NgModule({
    imports: [
        //Foundation
        FoundationModule,
        FoundationJobsModule,

        //Valkyrie
        BrowserModule,
        ServicesModule,
        DirectivesModule,
        PipesModule,
        ComponentsModule,
        DirectivesModule,
        VisualisationsModule,
        ReportsModule,
        MaintenanceModule,
        FleetModule,
        TmsModule,
        DashboardModule,
        CameraModule,
        HelpModule,
        AlertsModule,
        TemperatureModule,
        TachoModule
    ],
    declarations: [],
    entryComponents: [],
    exports: [],
    providers: [
        //{
        //    provide: ErrorHandler,
        //    useClass: RaygunErrorHandler
        //},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        }]
    //providers: [{ provide: ErrorHandler, useFactory: errorHandlerFactory }]
    //schemas: [NO_ERRORS_SCHEMA] // https://scotch.io/tutorials/angular-2-transclusion-using-ng-content - Unhandled Promise rejection: Template parse errors: 'card-body' is not a known elemen
})
export class NgAppModule {
    constructor() {
    }

    ngDoBootstrap() {
    }
}
